<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="memberlist inner-wrap">
  <div class="search-condition1">
    <div class="name-search">
       <!-- class="active"//-->
      <a [ngClass]="{active: search.searchText=='ㄱ'}" (click)="searchClick('ㄱ')" class="cp">ㄱ</a>
      <a [ngClass]="{active: search.searchText=='ㄴ'}" (click)="searchClick('ㄴ')" class="cp">ㄴ</a>
      <a [ngClass]="{active: search.searchText=='ㄷ'}" (click)="searchClick('ㄷ')" class="cp">ㄷ</a>
      <a [ngClass]="{active: search.searchText=='ㄹ'}" (click)="searchClick('ㄹ')" class="cp">ㄹ</a>
      <a [ngClass]="{active: search.searchText=='ㅁ'}" (click)="searchClick('ㅁ')" class="cp">ㅁ</a>
      <a [ngClass]="{active: search.searchText=='ㅂ'}" (click)="searchClick('ㅂ')" class="cp">ㅂ</a>
      <a [ngClass]="{active: search.searchText=='ㅅ'}" (click)="searchClick('ㅅ')" class="cp">ㅅ</a>
      <a [ngClass]="{active: search.searchText=='ㅇ'}" (click)="searchClick('ㅇ')" class="cp">ㅇ</a>
      <a [ngClass]="{active: search.searchText=='ㅈ'}" (click)="searchClick('ㅈ')" class="cp">ㅈ</a>
      <a [ngClass]="{active: search.searchText=='ㅊ'}" (click)="searchClick('ㅊ')" class="cp">ㅊ</a>
      <a [ngClass]="{active: search.searchText=='ㅋ'}" (click)="searchClick('ㅋ')" class="cp">ㅋ</a>
      <a [ngClass]="{active: search.searchText=='ㅌ'}" (click)="searchClick('ㅌ')" class="cp">ㅌ</a>
      <a [ngClass]="{active: search.searchText=='ㅍ'}" (click)="searchClick('ㅍ')" class="cp">ㅍ</a>
      <a [ngClass]="{active: search.searchText=='ㅎ'}" (click)="searchClick('ㅎ')" class="cp">ㅎ</a>
      <a [ngClass]="{active: search.searchText=='etc'}" (click)="searchClick('기타')" class="cp etc">기타</a>
    </div>
  </div>

  <div class="search-condition">
   <div class="search-input">
     <div class="select" [ngClass]="{on: isSelectOn}" (click)="isSelectOn=!isSelectOn" (mouseleave)="isSelectOn=false">
       <div class="selected-item">{{isSelectTxt}}</div>
       <ul class="select-item">
         <li (click)="selectSearchType1('all')">전체</li>
         <li (click)="selectSearchType1('company')">회사명</li>
         <li (click)="selectSearchType1('goods')">생산제품</li>
       </ul>
     </div>

     <input type="text" [(ngModel)]="search.searchText" class="input-txt" (keypress)="searchList($event)" />
     <button type="button" class="search-btn" (click)="searchWordList();">검색</button>
     <button type="button" class="reset-btn" (click)="initSearch();">초기화</button>
   </div>
 </div>

 <div class="member-list">
   <div class="member" *ngFor='let item of data'>
     <div class="name">{{item.companyName}}</div>
     <div class="ename">{{item.companyNameEng}}</div>
     <div class="link">
       <a class="link1 cp" (click)="openMember(item)">상세보기</a>
       <a href="http://{{item.homepage}}" target="_blank" class="link2">홈페이지</a>
     </div>
     <div class="product line"><span>{{item.productKor}}</span></div>
     <div class="product">
      <span *ngIf="item.productEng">{{item.productEng}}</span>
      <span *ngIf="!item.productEng">&nbsp;</span>
     </div>
   </div>
 </div>

 <div class="cb"></div>

 <div class="pagination-area">
   <ngb-pagination
     [(page)]="search.no"
     [pageSize]="search.row"
     [maxSize]="maxSize"
     [collectionSize]="totalCount"
     [boundaryLinks]="true"
     (pageChange)="loadPage($event)"
     >
     <ng-template ngbPaginationFirst>&lt;&lt;</ng-template>
     <ng-template ngbPaginationLast>&gt;&gt;</ng-template>
     <ng-template ngbPaginationPrevious>&lt;</ng-template>
     <ng-template ngbPaginationNext>&gt;</ng-template>
   </ngb-pagination>
 </div>
</div>

<app-footer></app-footer>